import React, { useEffect, useState, useRef, useMemo } from "react";
import { LanguageBoxWrapper } from "/";
import { PrimaryButton, ButtonText } from "Buttons";
import {
  useSpring,
  useChain,
  useTransition,
  animated,
  config,
} from "react-spring";
import { GetTextColor } from "Helpers/ColorHelper";

import { useSelector } from "react-redux";
import { useMeasure } from "react-use";
import { useGlobal } from "reactn";

export const LanguageBox = ({ languages, className }) => {
  const [theme] = useGlobal("theme");
  const defaultHeight = "0px";
  const [ref, { height }] = useMeasure();

  const state = useSelector(({ languageField }) => languageField);
  const springRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(defaultHeight);
  let buttonRefs = [];
  useEffect(() => {
    if (state.show) buttonRefs[0] && buttonRefs[0].focus();
  }, [state.show]);
  const transRef = useRef();
  const expand = useSpring({
    ref: springRef,
    config: config.stiff,
    height: state.show ? `${contentHeight}px` : defaultHeight,
    zIndex: "10",
  });
  useChain([transRef, springRef], [0, state.show ? 0.3 : 0.1]);
  useEffect(() => {
    setContentHeight(height);

    window.addEventListener("resize", setContentHeight(height));

    return window.removeEventListener("resize", setContentHeight(height));
  }, [height]);

  const data = [
    {
      name: "inputContent",
      id: 2093845,
    },
  ];
  const transition = useTransition(
    state.show ? data : [],
    (item) => item.name,
    {
      ref: transRef,
      unique: true,
      trail: 400 / data.length,
      from: {
        opacity: 0,
        width: "100%",
        transform: "translateY(-2rem)",
      },
      enter: {
        height: "100%",
        opacity: 1,
        width: "100%",
        transform: "translateY(0rem)",
      },
      leave: {
        opacity: 0,
        width: "100%",
        transform: "translateY(-2rem)",
      },
    }
  );
  return (
    <animated.div style={expand} className={className}>
      <LanguageBoxWrapper ref={ref}>
        {transition.map(({ item, key, props }) => (
          <animated.div style={props} key={`language-box-transition-${key}`}>
            <LanguageBoxWrapper open={state.show} bgColor={theme.colors.bg2}>
              {languages.LanguageObjects.map((lang, i) => {
                const { Name, Url, TwoLetterISO, IsActive } = lang;
                return (
                  <div lang={TwoLetterISO} key={`language-box-item-${i}`}>
                    <PrimaryButton
                      widthsmall="160px"
                      ref={(ref) => (buttonRefs[i] = ref)}
                      href={!IsActive ? Url : "#"}
                      margin="0 1rem"
                      smallmargin="0 1rem"
                      focedBgColor={IsActive && theme.colors.primary}
                      disabled={IsActive}
                      forcedColor={
                        IsActive && GetTextColor(theme.colors.primary).textColor
                      }
                      transition={false}
                    >
                      <ButtonText transition={false} heading={`language ${Name}`}>{Name}</ButtonText>
                    </PrimaryButton>
                  </div>
                );
              })}
            </LanguageBoxWrapper>
          </animated.div>
        ))}
      </LanguageBoxWrapper>
    </animated.div>
  );
};
